export const sunmary = [ // 交易汇总表头
  {
    label: '结算时间', prop: 'time', width: '220px', align: 'center', key: '1',
  },
  {
    label: '门店数', prop: 'shopCount', width: '150px', align: 'center', key: '2',
  },
  {
    label: '收款金额（元）', prop: 'collectAmount', tips: '收款成功的金额总和', align: 'center', key: '3',
  },
  {
    label: '收款笔数（笔）', prop: 'collectCount', tips: '收款成功的笔数总和', width: '150px', align: 'center', key: '4',
  },
  {
    label: '退款金额（元）', prop: 'refundAmount', tips: '退款成功的金额总和', width: '150px', align: 'center', key: '5',
  },
  {
    label: '退款笔数（笔）', prop: 'refundCount', tips: '退款成功的笔数总和', width: '150px', align: 'center', key: '6',
  },
  {
    label: '营业收入（元）', prop: 'revenue', tips: '营业收入=收款成功金额-退款成功金额，即实际收入金额', width: '150px', align: 'center', key: '7',
  },
  {
    label: '手续费（元）', prop: 'serviceCharge', width: '150px', align: 'center', key: '8',
  },
  {
    label: '补贴金额（元）', prop: 'subsidy', width: '150px', align: 'center', key: '9',
  },
  {
    label: '补贴后手续费（元）', prop: 'afterAllowancesServiceCharge', width: '150px', align: 'center', key: '10',
  },
  {
    label: '结算金额（元））', prop: 'settleAmount', tips: '微信/支付宝/银联二维码/刷卡交易的汇总结算金额', width: '150px', align: 'center', key: '11',
  },
  {
    label: '数字人民币结算金额（元）', prop: 'digitalCurrencySettleAmount', tips: '数字人民币交易的汇总结算金额', width: '220px', align: 'center', key: '12',
  },
];
export const storesc = [ // 门店汇总表头
  {
    label: '结算时间', prop: 'time', width: '220px', align: 'center', key: '13',
  },
  {
    label: '门店名称', prop: 'shopName', width: '150px', align: 'center', key: '14',
  },
  {
    label: '商户编号', prop: 'merchantId', width: '150px', align: 'center', key: '15',
  },
  {
    label: '收款金额（元）', prop: 'collectAmount', tips: '收款成功的金额总和', width: '150px', align: 'center', key: '16',
  },
  {
    label: '收款笔数（笔）', prop: 'collectCount', tips: '收款成功的笔数总和', width: '150px', align: 'center', key: '17',
  },
  {
    label: '退款金额（元）', prop: 'refundAmount', tips: '退款成功的金额总和', width: '150px', align: 'center', key: '18',
  },
  {
    label: '退款笔数（笔）', prop: 'refundCount', tips: '退款成功的笔数总和', width: '150px', align: 'center', key: '19',
  },
  {
    label: '营业收入（元）', prop: 'revenue', tips: '营业收入=收款成功金额-退款成功金额，即实际收入金额', width: '150px', align: 'center', key: '20',
  },
  {
    label: '手续费（元）', prop: 'serviceCharge', width: '150px', align: 'center', key: '21',
  },
  {
    label: '补贴金额（元）', prop: 'subsidy', width: '150px', align: 'center', key: '22',
  },
  {
    label: '补贴后手续费（元）', prop: 'afterAllowancesServiceCharge', width: '150px', align: 'center', key: '23',
  },
  {
    label: '结算金额（元））', prop: 'settleAmount', tips: '微信/支付宝/银联二维码/刷卡交易的汇总结算金额', width: '150px', align: 'center', key: '24',
  },
  {
    label: '数字人民币结算金额（元）', prop: 'digitalCurrencySettleAmount', tips: '数字人民币交易的汇总结算金额', width: '220px', align: 'center', key: '25',
  },
];
export const pointc = [// 收银点汇总表头
  {
    label: '结算时间', prop: 'time', width: '220px', align: 'center', key: '26',
  },
  {
    label: '门店名称', prop: 'shopName', width: '150px', align: 'center', key: '27',
  },
  {
    label: '商户编号', prop: 'merchantId', width: '150px', align: 'center', key: '28',
  },
  {
    label: '收银点名称', prop: 'cashierAreaName', align: 'center', key: '29',
  },
  {
    label: '收款金额（元）', prop: 'collectAmount', tips: '收款成功的金额总和', width: '150px', align: 'center', key: '30',
  },
  {
    label: '收款笔数（笔）', prop: 'collectCount', tips: '收款成功的笔数总和', width: '150px', align: 'center', key: '31',
  },
  {
    label: '退款金额（元）', prop: 'refundAmount', tips: '退款成功的金额总和', width: '150px', align: 'center', key: '32',
  },
  {
    label: '退款笔数（笔）', prop: 'refundCount', tips: '退款成功的笔数总和', width: '150px', align: 'center', key: '33',
  },
  {
    label: '营业收入（元）', prop: 'revenue', tips: '营业收入=收款成功金额-退款成功金额，即实际收入金额', width: '150px', align: 'center', key: '34',
  },
];
export const wayc = [// 收款方式汇总表头
  {
    label: '门店名称', prop: 'shopName', width: '150px', align: 'center', key: '35',
  },
  {
    label: '商户编号', prop: 'merchantId', width: '150px', align: 'center', key: '36',
  },
  {
    label: '交易渠道', prop: 'transChannel', width: '150px', align: 'center', key: '37',
  },
  {
    label: '笔数占比（%）', prop: 'countRatio', tips: '交易成功笔数/总交易成功笔数*100%', width: '150px', align: 'center', key: '38',
  },
  {
    label: '收款金额（元）', prop: 'collectAmount', tips: '收款成功的金额总和', width: '150px', align: 'center', key: '39',
  },
  {
    label: '收款笔数（笔）', prop: 'collectCount', tips: '收款成功的笔数总和', width: '150px', align: 'center', key: '40',
  },
  {
    label: '退款金额（元）', prop: 'refundAmount', tips: '退款成功的金额总和', width: '150px', align: 'center', key: '41',
  },
  {
    label: '退款笔数（笔）', prop: 'refundCount', tips: '退款成功的笔数总和', width: '150px', align: 'center', key: '42',
  },
  {
    label: '营业收入（元）', prop: 'revenue', tips: '营业收入=收款成功金额-退款成功金额，即实际收入金额', width: '150px', align: 'center', key: '43',
  },
  {
    label: '手续费（元）', prop: 'serviceCharge', align: 'center', key: '44',
  },
];
